app.controller("SubjectMigrationController", [
    "$scope", "StaticData", "ProgramService", "Migration", "Subject", "InfoModal", "toastr", "$stateParams", "$state",
    function ($scope, StaticData, ProgramService, Migration, Subject, InfoModal, toastr, $stateParams, $state) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.chosenPrograms = {};
        $scope.chosenSubjects = {};
        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
            $scope.emisSubject = $stateParams.subject;
            $scope.emisProgram = $stateParams.emisProgram;
        });

        $scope.$watch('emisProgram', function(program) {
            if (program && program.program) {
                $state.go(".", {program: program.program, emisProgram: program._id});
            }
        }, true);

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            Migration.list({
                page: page,
                limit: $scope.itemsPerPage,
                program: $stateParams.program,
                subject: $stateParams.subject
            }).then(function(data) {
                $scope.migrations = data.docs;
                $scope.totalItems = data.total;
                _($scope.migrations).each(function(migration) {
                    if (migration.newProgram && !$scope.chosenPrograms[migration.program]) {
                        ProgramService.fetchOne(migration.newProgram).then(function(program) {
                            $scope.chosenPrograms[migration.program] = program;
                        })
                    }
                });
                cb()
            })
        }

        $scope.getEmisPrograms = function (query) {
            return Migration.searchProgram(query).then(function(data) {
                return data;
            })
        };

        $scope.getEmisSubjects = function () {
            $state.go(".", {subject: $scope.emisSubject});
        };

        $scope.getPrograms = function (query) {
            return ProgramService.search({name: query}).then(function(data) {
                return data;
            })
        };

        $scope.getSubjects = function (query, migration) {
            var program = $scope.chosenPrograms[migration];
            return Subject.wrappersList({query: query, program: program._id}).then(function(data) {
                return data.docs;
            })
        };

        $scope.save = function (migration) {
            var program = $scope.chosenPrograms[migration.program];
            var subject = $scope.chosenSubjects[migration.subject];
            if (!program || !program._id || !subject || !subject._id) {
                return toastr.error('', 'პროგრამა ან საგანი არაა არჩეული სრულად.');
            }

            Migration.save({
                newProgram: program._id,
                newSubject: subject._id,
                migration: migration._id
            }).then(function (data) {
                loadPage($stateParams.page)
            })
        };

        $scope.refresh = function () {
            $state.go(".", {subject: null, program: null, emisProgram: null});
        };
    }
]);